<template>
  <div>
    <Header></Header>
    <div class="userbanner">
      <div class="usercenter">用户中心</div>
    </div>
    <div class="app-wrap">
      <div class="app-background">
        <div class="panel">
          <div class="panel-left">
            <el-menu
              router
              :default-active="activeMenu"
              unique-opened
              active-text-color="#0385f1"
              text-color="#a2a2a2"
            >
              <div class="role-menu" v-for="item in list" :key="item.index">
                <el-menu-item v-if="!item.child.length" :index="item.path">
                  <i :class="'iconfont '+item.icon"></i>
                  {{item.name}}
                </el-menu-item>
                <el-submenu v-else :index="item.index">
                  <template slot="title">
                    <i :class="'iconfont '+item.icon"></i>
                    <span>{{ item.name }}</span>
                  </template>
                  <el-menu-item v-for="(v,i) in item.child" :key="i" :index="v.path">{{ v.name }}</el-menu-item>
                </el-submenu>
              </div>
            </el-menu>
          </div>
          <div class="panel-right">
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import "@/assets/iconfont/iconfont.css";
import Header from "./header.vue";
import Footer from "./footer.vue";
import { mapGetters,mapMutations } from "vuex";
import { Base64 } from "js-base64";
import { getUserInfo } from "@/api/index";
export default {
  components: { Header, Footer },
  data() {
    return {
      list: [],
      list_company: [
        {
          name: "入库申请查询",
          icon: "icon-sousuo",
          index: "1",
          path: "/usercenter/applyHistory",
          commonPath: "/usercenter/applyHistory",
          child: []
        },
        {
          name: "异议记录",
          icon: "icon-jilu",
          index: "2",
          path: "/usercenter/objection",
          commonPath: "/usercenter/objection",
          child: []
        },
        {
          name: "基础信息管理",
          icon: "icon-shezhi",
          index: "3",
          child: [
            {
              name: "重点研发项目管理",
              path: "/usercenter/importantprojectManage",
              commonPath: "/usercenter/importantprojectManage"
            },
            {
              name: "专利或技术获各级奖励管理",
              path: "/usercenter/prizeManage",
              commonPath: "/usercenter/prizeManage"
            },
            {
              name: "经济指标数据管理",
              path: "/usercenter/economicManage",
              commonPath: "/usercenter/economicManage"
            },
            {
              name: "自主商标品牌建设情况管理",
              path: "/usercenter/brandManage",
              commonPath: "/usercenter/brandManage"
            },
            {
              name: "参与专利池运营情况管理",
              path: "/usercenter/patentpoolManage",
              commonPath: "/usercenter/patentpoolManage"
            },
            {
              name: "专利转化指标数据管理",
              path: "/usercenter/patenttransManage",
              commonPath: "/usercenter/patenttransManage"
            }
          ]
        }
      ],
      list_singer: [
        {
          name: "异议记录",
          icon: "icon-jilu",
          index: "2",
          path: "/usercenter/objection",
          commonPath: "/usercenter/objection",
          child: []
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["appUserType"]),
    activeMenu() {
      const route = this.$route;
      const { path } = route;
      // let paths = "";
      // this.list.forEach(e => {
      // e.path.forEach(i => {
      //   if (i.commonPath && path.startsWith(i.commonPath)) {
      //     paths = i.path;
      //     return;
      //   } else if (!i.commonPath && path == i.path) {
      //     paths = i.path;
      //     return;
      //   }
      // });
      // });
      return path;
      // return '1'
    }
  },
  mounted() {
    if(this.appUserType){
      this.loadmenu()
    }else if (localStorage.getItem("access_token")) {
      getUserInfo().then(res => {
        this.SET_APPUSERTYPE(res.data.appUserType);
        this.loadmenu()
      });
    } else {
      this.$confirm("请先登录！", "提示", {
        confirmButtonText: "前往法人登录",
        cancelButtonText: "前往个人登录",
        distinguishCancelAndClose: true,
        type: "warning"
      })
        .then(() => {
          window.open(
            `${
              process.env.VUE_APP_DOMAINNAME
            }/cms/goDestAddress?url=${Base64.encode(
              window.location.href
            )}&mod=${encodeURI("金种子法人")}`
          );
        })
        .catch(action => {
          if (action === "cancel") {
            window.open(
              `${
                process.env.VUE_APP_DOMAINNAME
              }/cms/goDestAddressPerson?url=${Base64.encode(
                window.location.href
              )}&mod=${encodeURI("金种子个人")}`
            );
          }
        });
    }
  },
  methods: {
    ...mapMutations(["SET_APPUSERTYPE"]),
    loadmenu() {
      console.log('this.appUserType',this.appUserType)
      if (this.appUserType == "UTR_COMPANY") {
        this.list = this.list_company;
      } else if (this.appUserType == "UTR_SINGER") {
        this.list = this.list_singer;
      }
    },
  }
};
</script>
<style scoped lang="less">
.app-wrap {
  width: 100%;
  background-color: #f4f6fa;
}
.app-background {
  width: 1200px;
  margin: 0 auto;
  padding: 30px 0;
}

#banner-wrap {
  width: 100%;
  // max-width: 1200px;
  height: 520px;
  // background-color: blue;

  background-size: 100% 100%;
}
.apply-img {
  width: 100%;
  height: 180px;
  background-color: #a7d0fe;
}
.userbanner {
  width: 100%;
  padding: 30px 0 0;
  background-image: linear-gradient(to bottom, #d2e3fa, #eff2f9);
}
.usercenter {
  height: 118px;
  width: 1200px;
  margin: 0 auto;
  border-radius: 10px;
  background: url("~@/assets/yonghuzhongxin.png");
  background-size: 100% 100%;
  overflow: hidden;
  color: #fff;
  line-height: 118px;
  font-size: 24px;
  font-weight: 700;
  text-indent: 60px;
  letter-spacing: 4px;
}
.applybox {
  display: flex;
  padding: 30px 0;
  justify-content: space-between;
  background-color: #f5f6fa;
  .apply_button {
    border-radius: 24.78px;
    font-size: 18px;
    cursor: pointer;
    padding: 12px 60px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #3f93f6;
  }
  .apply_button.active {
    color: #fff;
    background-color: #3f93f6;
  }
}
.panel {
  display: flex;
  justify-content: space-between;
  height: 820px;
  .panel-left {
    width: 280px;
    height: 100%;
    margin-right: 30px;
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 20px 0 20px 20px;
  }
  .panel-right {
    width: 890px;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
  }
}
/deep/ .el-menu {
  border-right: none;

  .el-submenu {
    .el-menu-item {
      text-indent: 20px;
    }

    .el-menu-item.is-active {
      background: url(~@/assets/submenu-bg.png) 40px 7px no-repeat;
    }
  }
  .el-submenu.is-opened .el-submenu__title {
    background: url(~@/assets/menu-bg.png);
    background-size: 100% 100%;
    i,
    span {
      color: #fff;
    }
  }
  .el-submenu__title i,
  .el-submenu__title span {
    color: #333;
  }
}
.iconfont {
  font-size: 16px;
  margin: 0 8px 0 3px;
}
/deep/ .role-menu > .el-menu-item.is-active {
  padding-left: 20px;
  color: rgb(162, 162, 162);
  background: url(data:image/png;base64,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)
    3px 9px no-repeat;
  color: #3f93f6;
}
</style>